<template>
  <div v-show="visible" :class="barClass" :style="barStyle"></div>
</template>

<script>
import { cx } from '~/common/utils';
import { queryClient } from '~/root/queries/query-client';

export default {
  name: 'TopLoadingBar',
  props: {
    top: {
      type: String,
    },
  },
  data() {
    return {
      visible: false,
      progress: 0,
      interval: null,
      fetching: false,
      finishingTimeout: null,
    };
  },
  watch: {
    fetching(newVal) {
      if (newVal) {
        this.start();
      } else {
        this.finish();
      }
    },
  },
  computed: {
    barStyle() {
      return {
        width: this.progress + '%',
        opacity: this.visible ? 1 : 0,
      };
    },
    barClass() {
      return cx('top-loading-bar', this.top ? 'top' : 'bottom');
    },
  },
  methods: {
    start() {
      this.visible = true;
      this.progress = 0;

      clearInterval(this.interval);
      clearTimeout(this.finishingTimeout);

      this.interval = setInterval(() => {
        if (this.progress < 90) {
          this.progress += Math.random() * 5;
        }
      }, 200);
    },
    finish() {
      clearInterval(this.interval);

      this.progress = 100;

      // Linger for 500ms at 100% before hiding
      this.finishingTimeout = setTimeout(() => {
        this.visible = false;

        // Reset progress only after it's hidden
        setTimeout(() => {
          this.progress = 0;
        }, 300); // match transition duration
      }, 500);
    },
  },
  created() {
    const checkFetching = () => (this.fetching = queryClient.isFetching() > 0);

    this.unsubscribe = queryClient.getQueryCache().subscribe(() => {
      this.fetching = queryClient.isFetching() > 0;
    });

    checkFetching();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.finishingTimeout);
    this.unsubscribe?.();
  },
};
</script>

<style scoped>
.top-loading-bar {
  display: block !important;
  left: 0;
  height: 2px;
  background-color: var(--color-kw-blue-1);
  z-index: 9999;
  transition:
    width 0.3s ease,
    opacity 0.3s ease;
  box-shadow: 0 0 4px color-mix(in srgb, var(--color-kw-blue-1) 20%, transparent);
}

.top-loading-bar.top {
  top: 0;
  position: fixed;
}

.top-loading-bar.bottom {
  bottom: -1px;
  position: absolute;
}
</style>
